// extracted by mini-css-extract-plugin
module.exports = {"success":"SnackbarWrapper__success__1LvYI","error":"SnackbarWrapper__error__SwpCp","default":"SnackbarWrapper__default__3aBju"};